import React, { useState } from 'react';
import { Button, Card, Typography, Space, Alert } from 'antd';
import { CameraOutlined } from '@ant-design/icons';
import BarcodeScannerModal from './BarcodeScannerModal';

const { Title, Text } = Typography;

const BarcodeTest = () => {
  const [scannerVisible, setScannerVisible] = useState(false);
  const [scannedCode, setScannedCode] = useState('');
  const [scanHistory, setScanHistory] = useState([]);

  const handleBarcodeScanned = (barcode) => {
    setScannedCode(barcode);
    setScanHistory(prev => [barcode, ...prev.slice(0, 9)]); // Keep last 10 scans
  };

  return (
    <div style={{ padding: '20px', maxWidth: '800px', margin: '0 auto' }}>
      <Title level={2}>
        <CameraOutlined /> Barcode Scanner Test
      </Title>
      
      <Text type="secondary" style={{ display: 'block', marginBottom: '20px' }}>
        Test the barcode scanner functionality. This should work on both desktop and mobile devices.
      </Text>

      <Space direction="vertical" size="large" style={{ width: '100%' }}>
        <Card>
          <Space direction="vertical" size="middle" style={{ width: '100%' }}>
            <Button
              type="primary"
              size="large"
              icon={<CameraOutlined />}
              onClick={() => setScannerVisible(true)}
            >
              Test Barcode Scanner
            </Button>

            {scannedCode && (
              <Alert
                message="Last Scanned Code"
                description={
                  <div>
                    <Text code style={{ fontSize: '16px' }}>{scannedCode}</Text>
                    <br />
                    <Text type="secondary" style={{ fontSize: '12px' }}>
                      Scanned at: {new Date().toLocaleString()}
                    </Text>
                  </div>
                }
                type="success"
                showIcon
              />
            )}
          </Space>
        </Card>

        {scanHistory.length > 0 && (
          <Card title="Scan History">
            <Space direction="vertical" size="small" style={{ width: '100%' }}>
              {scanHistory.map((code, index) => (
                <div key={index} style={{ 
                  padding: '8px', 
                  background: '#f5f5f5', 
                  borderRadius: '4px',
                  fontFamily: 'monospace'
                }}>
                  {code}
                </div>
              ))}
            </Space>
          </Card>
        )}

        <Card title="Mobile Compatibility Notes">
          <Space direction="vertical" size="small">
            <Text >• Make sure to allow camera permissions when prompted</Text>
            <Text >• Works best with good lighting conditions</Text>
            <Text >• Try both front and back cameras if available</Text>
            <Text >• Hold the barcode steady in the camera view</Text>
            <Text >• The scanner supports various barcode formats (EAN, UPC, Code128, etc.)</Text>
          </Space>
        </Card>
      </Space>

      <BarcodeScannerModal
        visible={scannerVisible}
        onClose={() => setScannerVisible(false)}
        onScan={handleBarcodeScanned}
        title="Test Barcode Scanner"
        allowManualInput={true}
      />
    </div>
  );
};

export default BarcodeTest;
